import { storybookReady } from '../../../core/js/utils'
let storybook

(async function() {
  storybook = await storybookReady()

  initModalOpeners(document)
})()

export function initModalOpeners(element) {
  const modalOpeners = element.querySelectorAll('[data-modal_opener]')

  if (modalOpeners) {
    const modalOpenerClick = (event) => {
        event.preventDefault()
        let modalIdentifier = event.currentTarget.dataset.modal_opener;
        let modalContent = document.querySelector('[data-modal_content=' + modalIdentifier + ']')
        if (!modalContent) {
          return
        }
        const modal = new tingle.modal({
          closeLabel: '',
          onClose: function () {
            var event = new CustomEvent('modal:close', { 'detail': { 'modalIdentifier': modalIdentifier } })
            window.dispatchEvent(event)
          }
        })
        modal.setContent(modalContent)
        modal.open()
      }
    modalOpeners.forEach(item => {
      item.removeEventListener('click', modalOpenerClick)
      item.addEventListener('click', modalOpenerClick)
    })
  }
}
